import { type ReactElement } from 'react';

export function DMHCPAlerts(): ReactElement {
  return <div />;
}